var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTricycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F27419;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.7,15.6 35.7,17 51.9,17 51.9,15.6 35.7,15.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,38.8c1.3,0,2.3,1,2.3,2.3c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3C43.6,39.9,44.6,38.8,45.9,38.8 L45.9,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,40.8l-14.8,0.3v-5.7c0-5.1,4.1-9.2,9.2-9.2h5.6V40.8L52.4,40.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "52.4,16.7 51,16.7 51,41.2 52.4,41.2 52.4,16.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.4,13c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7H27.5c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 H54.4L54.4,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6,40.3H34v-2c0-0.9,0.8-1.7,1.7-1.7h2V40.3L37.6,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,28.1c0.1-0.3-0.1-0.7-0.5-0.8c-0.3-0.1-0.7,0.1-0.8,0.5l-3,13.5c-0.1,0.3,0.1,0.7,0.5,0.8 c0.3,0.1,0.7-0.1,0.8-0.5L16.5,28.1L16.5,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1,28c0-0.4-0.3-0.6-0.6-0.6h-1.6c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6h1.6 C17.9,28.6,18.1,28.3,18.1,28L18.1,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.3,26.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C17.2,27.3,17.7,26.8,18.3,26.8 L18.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.3,27.2c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7 C17.6,27.5,17.9,27.2,18.3,27.2L18.3,27.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.6,33.4 18.2,33.4 18.2,34.7 28.6,34.7 28.6,33.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,32c0.1-0.3-0.2-0.7-0.5-0.7c-0.3-0.1-0.7,0.2-0.7,0.5l-1.5,8.3c-0.1,0.3,0.2,0.7,0.5,0.7 c0.3,0.1,0.7-0.2,0.7-0.5L29.8,32L29.8,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,30.1c0,0,6.5,8.5,7.6,10c0.1,0.1,0.3,0.2,0.4,0.2c2.8,0,27.8,0,27.8,0V42c0,0-23.4,0-27.9,0 c-0.4,0-0.9-0.2-1.1-0.6c-1.6-2.2-7.1-9.6-7.1-9.6L15.9,30.1L15.9,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,29.9c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1C26.7,30.3,27.1,29.9,27.7,29.9L27.7,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31,30c0.6,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2C29.8,30.5,30.4,30,31,30L31,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,30l-3.4-0.1l0,1.9c1-0.3,2-0.3,3.1,0.5L31.1,30L31.1,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,39.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C11.4,40.3,12.1,39.6,13,39.6 L13,39.6z M13,40.8c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C12.6,40.9,12.8,40.8,13,40.8L13,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,34.2c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9S6,45,6,41.2S9.1,34.2,13,34.2L13,34.2z M13,35.5 c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6S9.9,35.5,13,35.5L13,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,34.2c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9c-3.8,0-6.9-3.1-6.9-6.9S42,34.2,45.9,34.2L45.9,34.2z  M45.9,35.5c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6S42.8,35.5,45.9,35.5L45.9,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26,38.9c1.3,0,2.3,1,2.3,2.3c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3C23.7,39.9,24.7,38.9,26,38.9L26,38.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,41.2c-0.2-0.2-0.4-0.2-0.6,0l-2.2,2.1c-0.2,0.2-0.2,0.4,0,0.6c0.2,0.2,0.4,0.2,0.6,0l2.2-2.1 C26.1,41.7,26.1,41.4,25.9,41.2L25.9,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,40.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6C25.4,40.9,25.7,40.6,26,40.6L26,40.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.9,43.6c0-0.2-0.2-0.4-0.4-0.4h-2.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.1 C24.8,43.9,24.9,43.8,24.9,43.6L24.9,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.9,39.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C44.3,40.3,45,39.6,45.9,39.6 L45.9,39.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.1,11.7 31.2,12.5 35.7,17 36.6,16.2 32.1,11.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "52.3,18.9 51.1,18.9 51.1,12.5 52.3,12.5 52.3,18.9  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTricycle);
export default __webpack_public_path__ + "static/media/tricycle.4d4e5943ac870ebe21f2096fa9366246.svg";
export { ForwardRef as ReactComponent };